/**
 * The "user has chosen / been routed to a company this browser session" flag.
 * Set by CompanyGate once a multi-company user picks a company so subsequent
 * loads skip /select-company. MUST be cleared on logout — otherwise the next
 * (different) user on the same browser inherits the prior user's choice and
 * skips the picker. Single source of truth so the gate and the logout flow
 * never drift on the key.
 */
export const COMPANY_CHOSEN_KEY = "onshelf.companyChosen";

/** An invitation acceptance is also an explicit company selection. */
export function chooseCompany(): void {
  try {
    localStorage.setItem(COMPANY_CHOSEN_KEY, "1");
    localStorage.removeItem("onshelf.selectedStoreId");
  } catch {
    /* ignore disabled storage */
  }
}

export function clearCompanyChosen(): void {
  try {
    localStorage.removeItem(COMPANY_CHOSEN_KEY);
  } catch {
    /* ignore disabled storage */
  }
}
